export const BASE_URL =
  typeof window === "undefined"
    ? process.env.API_URL || process.env.NEXT_PUBLIC_BASE_URL
    : process.env.NEXT_PUBLIC_BASE_URL;
export const PLACEHOLDER_IMAGE = "/no-image-found.png";
export const PLACEHOLDER_ALT = "no image found";
